import type {
  CycleCountFrequency,
  CycleCountScopeType,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const createCycleCountScheduleAtom = createMutationAtomFactory(
  'inventory.createCycleCountSchedule',
  (params: {
    facilityId: string;
    name: string;
    frequency: CycleCountFrequency;
    scopeType: CycleCountScopeType;
    isBlindCount: boolean;
    defaultTolerancePercentage: number;
  }) => ({
    inventoryCycleCountScheduleCreate: {
      __args: {
        input: {
          facilityId: params.facilityId,
          name: params.name,
          frequency: params.frequency,
          scopeType: params.scopeType,
          isBlindCount: params.isBlindCount,
          defaultTolerancePercentage: params.defaultTolerancePercentage,
        },
      },
      id: true,
      facilityId: true,
      facility: {
        id: true,
        facilityName: true,
      },
      name: true,
      frequency: true,
      scopeType: true,
      isBlindCount: true,
      defaultTolerancePercentage: true,
      isActive: true,
      lastGeneratedAt: true,
      nextGenerationAt: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);

export const updateCycleCountScheduleAtom = createMutationAtomFactory(
  'inventory.updateCycleCountSchedule',
  (params: {
    id: string;
    name?: string;
    frequency?: CycleCountFrequency;
    scopeType?: CycleCountScopeType;
    isBlindCount?: boolean;
    defaultTolerancePercentage?: number;
  }) => ({
    inventoryCycleCountScheduleUpdate: {
      __args: {
        id: params.id,
        input: {
          name: params.name,
          frequency: params.frequency,
          scopeType: params.scopeType,
          isBlindCount: params.isBlindCount,
          defaultTolerancePercentage: params.defaultTolerancePercentage,
        },
      },
      id: true,
      facilityId: true,
      facility: {
        id: true,
        facilityName: true,
      },
      name: true,
      frequency: true,
      scopeType: true,
      isBlindCount: true,
      defaultTolerancePercentage: true,
      isActive: true,
      lastGeneratedAt: true,
      nextGenerationAt: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);

export const deleteCycleCountScheduleAtom = createMutationAtomFactory(
  'inventory.deleteCycleCountSchedule',
  (params: { id: string }) => ({
    inventoryCycleCountScheduleDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);

export const activateCycleCountScheduleAtom = createMutationAtomFactory(
  'inventory.activateCycleCountSchedule',
  (params: { id: string }) => ({
    inventoryCycleCountScheduleActivate: {
      __args: {
        id: params.id,
      },
      id: true,
      isActive: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);

export const deactivateCycleCountScheduleAtom = createMutationAtomFactory(
  'inventory.deactivateCycleCountSchedule',
  (params: { id: string }) => ({
    inventoryCycleCountScheduleDeactivate: {
      __args: {
        id: params.id,
      },
      id: true,
      isActive: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);
